query LookupAccountTransactionSearch(
  $lookupName: String!
  $businessUnitId: UUID
) {
  lookupAccountTransactionSearch(
    lookupName: $lookupName
    businessUnitId: $businessUnitId
    orderBy: LOOKUP_ACCOUNT_ASC
  ) {
    nodes {
      id
      lookupAccount
      lookupName
      projectAccount
      setAccount
    }
  }
}
